import type { JSX } from 'react';

import { NoteTypes } from '~constants/enums';
import { Notes } from '~formsShared/components/Notes';

/**
 * Renders notes. One-line render-only wrapper: this row has NO card
 * wrapper — the embedded legacy Notes renders its own Card and owns all
 * four note fields (no fork). Legacy passes ONLY defaultTab; defaultData
 * is a prop of the Contacts embed that Notes declares but never reads — do
 * not add it here.
 */
export function NotesPanel(): JSX.Element {
  return <Notes defaultTab={NoteTypes.ORDER} />;
}
